<template>
  <li
    v-if="state && showClear"
    class="margin-bottom-2xs margin-right-sm"
  >
    <button
      class="icon-facet-pill icon-facet-pill-clear tag flat rounded"
      style="
        --tag-background: transparent;
        --button-margin-bottom: 0;
        --button-hover-color: var(--fa-dk-blue);
        --button-active-color: var(--fa-dk-blue);
        --button-hover-background: transparent;
        --button-active-background: transparent;
        --button-active-border-width: var(--border-width-sm);
        --link-decoration-style: none;
        --link-decoration-line: none;
        --link-hover-decoration-style: none;
        --link-hover-decoration-line: none;
        --tag-padding: var(--spacing-sm) var(--spacing-md);
      "
      @click.prevent="clearSearch()"
    >
      Reset
      <span class="sr-only">All Filters + Queries</span>
    </button>
  </li>
</template>

<script>
  import { createWidgetMixin } from 'vue-instantsearch'
  import { connectClearRefinements } from 'instantsearch.js/es/connectors'

  export default {
    name: 'ClearWidget',

    mixins: [createWidgetMixin({ connector: connectClearRefinements })],

    props: {
      hasRefinements: {
        type: Boolean
      }
    },

    computed: {
      hasSearchQuery() {
        return this.state.instantSearchInstance.helper.state.query != ''
      },

      showClear() {
        return this.hasRefinements || this.hasSearchQuery
      }
    },

    methods: {
      clearSearch() {
        this.state.refine('')
        this.$emit('clearSearchQuery', '')
      }
    }
  }
</script>
